import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useWorkspaceSocket } from '@/hooks/workspace/useWorkspaceSocket'
import { LiveReportDocument } from '@/components/report/LiveReportDocument'

export function ReportViewerPage() {
  const { reportId } = useParams<{ reportId: string }>()
  const { events, connect, disconnect } = useWorkspaceSocket()
  useEffect(() => {
    connect()
    return () => disconnect()
  }, [connect, disconnect])

  return <LiveReportDocument reportId={reportId as string} events={events} />
}

export default ReportViewerPage
